module.exports = __webpack_public_path__ + "static/media/Protocol-Cameratoezicht-De-Kleine-Aapjes.c47537c3.pdf";